import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import { wrapEventHandler } from './Event.utils';
import { ChildrenPropType } from '../../../../services/proptypes';
import { EventPropType } from '../../types';
var defaultProps = {};
export default function Event(_ref) {
  var event = _ref.event,
    eventType = _ref.eventType,
    children = _ref.children;
  if (_isEmpty(event)) {
    return children;
  }
  return /*#__PURE__*/React.cloneElement(children, _objectSpread(_objectSpread({}, children.props), wrapEventHandler(event, eventType, children)));
}
Event.defaultProps = defaultProps;